import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { normalizeLang } from './i18n/languages';

// Minimal, non-intrusive i18n bootstrap to silence react-i18next warnings.
// Keeps a few strings so existing hooks work, but defaults to returning the key itself.
const resources = {
  pl: {
    overlays: {
      errorOverlay: {
        title: 'Wystąpił błąd',
        close: 'Zamknij',
        refresh: 'Odśwież',
      },
    },
    smallCompnenets: {
      dialog: {
        defaultAlertTitle: 'Informacja',
        defaultConfirmTitle: 'Potwierdź',
        buttons: {
          ok: 'OK',
          cancel: 'Anuluj',
        },
      },
    },
  },
};

const defaultLng = normalizeLang(typeof navigator !== 'undefined' ? navigator.language : 'pl');

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLng,
    fallbackLng: 'pl',
    ns: ['overlays', 'smallCompnenets'],
    defaultNS: 'overlays',
    interpolation: { escapeValue: false },
    returnNull: false,
    detection: false,
    debug: false,
  })
  .catch((err) => {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn('i18n init failed', err);
    }
  });

export default i18next;
